import { dataHooks } from '../../../../libs/dataHooks';

export const suggestionsDropdown = dataHooks<{
  relatedResultsList: {};
  resultsList: {};
  searchButton: {};
  dropdown: { opened: boolean };
}>('suggestionsDropdown');
